import { commonjsGlobal as u } from "./index168.js";
import { __exports as a } from "./index202.js";
import { c as i } from "./index204.js";
var p = u && u.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(a, "__esModule", { value: !0 });
a.default = m;
const s = p(i);
function m(o, f) {
  let e = null;
  if (!o || typeof o != "string")
    return e;
  const l = (0, s.default)(o), c = typeof f == "function";
  return l.forEach((r) => {
    if (r.type !== "declaration")
      return;
    const { property: n, value: t } = r;
    c ? f(n, t, r) : t && (e = e || {}, e[n] = t);
  }), e;
}
